import * as TypeGraphQL from "type-graphql";
export var DeadLetterStatus;
(function (DeadLetterStatus) {
    DeadLetterStatus["PENDING"] = "PENDING";
    DeadLetterStatus["RETRYING"] = "RETRYING";
    DeadLetterStatus["FAILED"] = "FAILED";
    DeadLetterStatus["RESOLVED"] = "RESOLVED";
    DeadLetterStatus["ARCHIVED"] = "ARCHIVED";
})(DeadLetterStatus || (DeadLetterStatus = {}));
TypeGraphQL.registerEnumType(DeadLetterStatus, {
    name: "DeadLetterStatus",
    description: undefined,
});
//# sourceMappingURL=DeadLetterStatus.js.map